import classNames from 'classnames'
import { ButtonHTMLAttributes, forwardRef } from 'react'

import styles from './button.module.css'

export interface LegacyButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: 'primary' | 'text'
    fullWidth?: boolean
}

export const Button = forwardRef<HTMLButtonElement, LegacyButtonProps>(function Button({
    children,
    className,
    fullWidth,
    type = 'button',
    variant = 'primary',
    ...rest
}, ref) {
    return (
        <button
            className={ classNames(
                styles.button,
                styles[variant],
                { [styles.fullWidth]: fullWidth },
                className,
            ) }
            ref={ ref }
            type={ type }
            { ...rest }
        >
            { children }
        </button>
    )
})
